var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewableEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.17 10.72c2.25-1.05 2.23-4.45 1.09-5.83a4 4 0 0 0-3.72-1.14c-3.38.42-4.8 5.55-1.24 7a5.13 5.13 0 0 0 3.87-.03Zm-2.49-5.9a3.15 3.15 0 0 1 3 .63c1.11 1.17 1.17 4.15-1.3 4.69a4.41 4.41 0 0 1-2.65-.31c-2.45-1.08-1.28-4.7.95-5.01Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63 2.1c.13-.44.62-1.8-.16-2.1-.11 0-.23 0-.4.34-.38.75-.44.66-.07 1.76a.34.34 0 0 0 .63 0Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79 11.81a.29.29 0 0 0-.42-.06 1.52 1.52 0 0 0-.51 1.05 3.14 3.14 0 0 0 .24 1.27.34.34 0 0 0 .68 0 3.49 3.49 0 0 0 .01-2.26Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32 6.85a2.57 2.57 0 0 0-2 .09c-.2.12-.25.22-.24.28s0 .21.13.26a2.15 2.15 0 0 0 2.24 0 .34.34 0 1 0-.13-.63Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.41 6.83c-1.36-.49-1.14-.12-1.9-.07a.34.34 0 1 0-.13.66c1.48.74 2.98-.24 2.03-.59Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18 3.8a.34.34 0 0 0 0-.48c-.08-.15-.47-1.16-1.35-1.24l-.18 0c-.82.11.99 2.25 1.53 1.72Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.31 2.49c.06-.31 0-.46-.13-.48S12.08 2 12 2c-.69.07-1.69 1.38-1.34 1.72s1.45-.19 1.65-1.23Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59 10.7c-.91.55-1 .43-1.49 1.56a.3.3 0 1 0 .45.39c.68-.41.77-.14 1.53-1.48a.34.34 0 0 0-.49-.47Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.24 10.61a.34.34 0 1 0-.48.47c.76 1.34.86 1.08 1.53 1.48a.29.29 0 1 0 .45-.38c-.47-1.18-.59-1.02-1.5-1.57Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.16 13.26c.26-.37.89-.92.72-1.58a.61.61 0 0 0-.37-.42 23.41 23.41 0 0 0-4.5.08.3.3 0 0 0 .06.6 15.82 15.82 0 0 1 4 .07 27.12 27.12 0 0 1-2.19 2.76 5.16 5.16 0 0 0-.88 1.11c-.47 1 1.23.67 2.2.66a57.24 57.24 0 0 1-5.54 5.72c1.59-4 2.72-5 1.64-5.42a21.82 21.82 0 0 1-2.3-.21c.26-.55 2-3.08 2.49-3.82a.34.34 0 0 0-.56-.39c-2.47 3.51-3.28 4.36-2.67 4.78a6.58 6.58 0 0 0 2.39.53c-.2.48-.6 1.05-.84 1.49-1 2.28-1.78 3.59-1.45 4.39A.59.59 0 0 0 16 24c1 0 6.54-5.79 7.38-7.23a1 1 0 0 0 .18-.82c-.21-.61-1.2-.47-2.05-.4a24.4 24.4 0 0 0 1.65-2.29Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.06 17.81c-.35-.52-.76-.27-.76 0a24.82 24.82 0 0 1 1 2.73 7.64 7.64 0 0 1-2.75-1 5.84 5.84 0 0 1-2.15-2.38 9.24 9.24 0 0 1-.59-1.8 2 2 0 0 1 .06-.82c.38-2-1.58-.14-.32 3.29a5.24 5.24 0 0 0 2.09 2.47 7.35 7.35 0 0 0 3 .93c-2.2.8-3.15 1-2.78 1.47.22.27 3.43-.49 4.07-.7a1.22 1.22 0 0 0 .7-.5.94.94 0 0 0 0-.53 19.35 19.35 0 0 0-1.57-3.16Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.37 6.75c.63.54 1-.24.54-.45a15.53 15.53 0 0 1-1.48-2.15 6.6 6.6 0 0 1 4.63 1 6.69 6.69 0 0 1 1.8 2.08c.6 1 .21 1.08.36 1.11-.09.61.39 1.58.61 0a5.84 5.84 0 0 0-1.17-3.21A5.07 5.07 0 0 0 19 3.41a7.17 7.17 0 0 0-3.07-.08c2.31-1.67 2.66-1.87 2.3-2.16s-.49.05-.69.16c-1 .52-3.54 1.57-3.6 2.29a.84.84 0 0 0 .15.51 18.94 18.94 0 0 0 2.28 2.62Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewableEnergy);
export default __webpack_public_path__ + "static/media/renewable-energy.d4bddbae6594aec830fd7d06cdd4a39d.svg";
export { ForwardRef as ReactComponent };